module.exports = __webpack_public_path__ + "img/hk1_mainland_bg.e633b38b.png";